

window.addEventListener("load", function () {
  const marquee2List = document.querySelectorAll(".tag-marquee.marquee2");
  const count = 20;

  marquee2List.forEach(function (marquee2) {
    for (let i = 0; i < count; i++) {
      const item = document.createElement("div");
      item.className = "text2";
      marquee2.appendChild(item);
    }
  });
});
